//Library Imports
import { Col, Row, Modal } from "antd";
import React, { useState } from "react";

//Local Imports
import { ReactComponent as Cross } from "../../../assets/img/icons/cross.svg";
import PlayButtonGreen from "../../../assets/img/icons/PlayButtonGreen.svg";
import videoThumb from "../../../assets/img/videoThumb.png";

//Style Imports
import styled from "styled-components";

// type Props = {
//   title: string;
//   icon: string;
// }

const AutomationVideoCard = (props: Props) => {
  // const { title, icon} = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <Wrapper onClick={showModal} style={{ backgroundImage: `url(${videoThumb})` }}>
        <Row justify="space-around" align="middle" className="video-action">
          <Col span={24} className="d-flex align-items-center">
            <div className="video-text">Watch Tutorial</div>
            <img src={PlayButtonGreen} alt="icon" />
          </Col>
        </Row>
      </Wrapper>
      <StyledModal
        centered
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        closeIcon={<Cross />}
        width={650}
        wrapClassName="workflow-modal"
        maskClosable={false}
        destroyOnClose={true}
      >
        <div className="text-center">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/Blnz8yfrR6s"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
            allowFullScreen
          ></iframe>
        </div>
      </StyledModal>
    </>
  );
};

export default AutomationVideoCard;

const Wrapper = styled.div`
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 8px;
  .video-action {
    background-color: transparent;
    border-radius: 8px;
    cursor: pointer;
    /* border: 1px solid #ffffff; */
    height: 100%;
    cursor: pointer;
    img {
      max-width: 64px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-width: 52px;
    }
    }
  }
  .video-text{
    font-family: 'Roboto Slab';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    letter-spacing: -0.6px;
    color: #001760;

    max-width: 99px;
    margin-left: 38px;
    margin-right: 7px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 24px;
      max-width: 86px;
    }
  }
`;

const StyledModal = styled(Modal)`
  /* .workflow-modal {
    }
  } */
  .ant-modal-content {
    border-radius: 8px;
    box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.0821427);
  }
`;
